export const sessionExpiredModalStatusSelector = state => state.displaySessionExpiredModal;
